const USER_FACING_EXPORT_ERRORS: Array<{ pattern: RegExp; message: string }> = [
  {
    pattern: /Nothing to export yet/i,
    message: "Start chatting first — we need at least one exchange to build a handout.",
  },
  {
    pattern: /Voice synthesis is not configured|ElevenLabs/i,
    message: "Voice notes are not available right now. Try a PDF or Word handout instead.",
  },
  {
    pattern: /OpenAI|handout summarize failed/i,
    message: "AI summarization is unavailable. We will still try a basic handout if possible.",
  },
  {
    pattern: /Sign in required/i,
    message: "Sign in to save resources from your chat.",
  },
];

function mapExportErrorMessage(raw: string): string {
  for (const { pattern, message } of USER_FACING_EXPORT_ERRORS) {
    if (pattern.test(raw)) return message;
  }
  return raw;
}

export async function readSupabaseInvokeError(
  invokeResult: { data: unknown; error: unknown },
): Promise<string | null> {
  const payload = invokeResult.data as { error?: string } | null;
  if (payload?.error) return mapExportErrorMessage(payload.error);

  const rawResponse =
    (invokeResult as unknown as { response?: Response }).response ??
    ((invokeResult.error as unknown as { context?: Response })?.context);

  if (!rawResponse || typeof rawResponse.clone !== "function") return null;

  try {
    const text = await rawResponse.clone().text();
    if (!text) return `HTTP ${rawResponse.status}`;

    try {
      const parsed = JSON.parse(text) as { error?: string; message?: string };
      if (parsed?.error) return mapExportErrorMessage(String(parsed.error));
      if (parsed?.message) return mapExportErrorMessage(String(parsed.message));
      return mapExportErrorMessage(`HTTP ${rawResponse.status}: ${text.slice(0, 200)}`);
    } catch {
      return `HTTP ${rawResponse.status}: ${text.slice(0, 200)}`;
    }
  } catch {
    return null;
  }
}
